import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
const b = bemClassBuilder('v-icon');
/**
 * Renders an icon as an inline SVG.
 * See /src/icons/README.md for more details.
 */
export const Icon = observer(({ name, className, viewBox, preserveAspectRatio, size, x, y }) => {
    return (_jsx("svg", Object.assign({ className: b.block({ [name]: true }, className), viewBox: viewBox, preserveAspectRatio: preserveAspectRatio, x: x, y: y }, { children: _jsx("use", { xlinkHref: `#v-icon_${name}`, width: size, height: size }) })));
});
Icon.displayName = 'Icon';
